import React, { useMemo } from 'react';
import { useFormikContext } from 'formik';

import { Box, ButtonText, Flex, SvgIcon, Text } from 'Components/Base';
import useCompatibleDisplay from 'Util/Hooks/useCompatibleDisplay';

import ConnectionSelector from '../ConnectionSelector';

const DIGIT_OPTIONS = ['0', '1', '2', '3', '4', '5', '6', '7', '8', '9'];
const LETTER_OPTIONS = ['A', 'B', 'C', 'D', 'E', 'F', 'G', 'H', 'I', 'J'];

const CONNECTION_FIELDS = [
  { answerOptions: DIGIT_OPTIONS, placeholder: 'หลักที่ 1' },
  { answerOptions: DIGIT_OPTIONS, placeholder: 'หลักที่ 2' },
  { answerOptions: LETTER_OPTIONS, placeholder: 'หลักที่ 3' },
];

const DEFAULT_ANSWERS = Array(5).fill(['', '', '']);

const QuizConnectionAnswer = ({ name }) => {
  const { values, setFieldValue } = useFormikContext();
  const { isMobile } = useCompatibleDisplay();

  const currentAnswers = useMemo(() => values[name] || DEFAULT_ANSWERS, [values, name]);

  const getUpdatedAnswers = (index, fieldIndex, value) => {
    return currentAnswers.map((row, i) =>
      i === index ? row.map((cell, j) => (j === fieldIndex ? value : cell)) : row
    );
  };

  const handleOnChange = (index, fieldIndex, value) => {
    if (currentAnswers[index][fieldIndex] !== value) {
      setFieldValue(name, getUpdatedAnswers(index, fieldIndex, value));
    }
  };

  const handleClearRow = (index) => {
    setFieldValue(
      name,
      currentAnswers.map((row, i) => (i === index ? ['', '', ''] : row))
    );
  };

  return currentAnswers.map((_, index) => (
    <Box key={index} mt={index === 0 ? 0 : 4}>
      <Text textStyle="subtitle2" mb={2} fontWeight="600">
        {`คำตอบที่ ${index + 1}`}
      </Text>
      <Flex
        flexDirection={isMobile ? 'column' : 'row'}
        alignItems={isMobile ? 'flex-start' : 'center'}
      >
        <Flex>
          {CONNECTION_FIELDS.map((field, fieldIndex) => (
            <ConnectionSelector
              key={fieldIndex}
              currentAnswer={currentAnswers[index][fieldIndex]}
              handleAnswerSelection={(value) => handleOnChange(index, fieldIndex, value)}
              answerOptions={field.answerOptions}
              placeholder={field.placeholder}
            />
          ))}
        </Flex>
        <Box>
          <ButtonText
            onClick={() => handleClearRow(index)}
            style={{ padding: '8px', textDecoration: 'none', marginTop: isMobile ? 8 : 0 }}
          >
            <Flex alignItems="center">
              <SvgIcon icon={SvgIcon.ICON_LIST.REFRESH} size={24} style={{ marginRight: 8 }} />
              <Text textStyle="body1" fontWeight={700}>
                {'ล้างค่า'}
              </Text>
            </Flex>
          </ButtonText>
        </Box>
      </Flex>
    </Box>
  ));
};

export default QuizConnectionAnswer;
